import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Paper } from '@mui/material';
import { FullSizeColumn } from '../../../Components/FlexBox';
import CaptionValue from '../../../Components/CaptionValue/CaptionValue';
import StatusInfo from '../../../Components/ContactListWrapper/EntryComponent/StatusInfo';

const LongPracticeInfoWidget = function LongPracticeInfoWidget({ data }) {
  return (
    <FullSizeColumn
      style={{
        overflow: 'auto',
        padding: '16px',
        display: 'flex',
        gap: '16px',
        flexDirection: 'column',
        textOverflow: 'ellipsis',
      }}
    >
      <CaptionValue
        direction="row"
        gap="4px"
        caption="NATIONALAGREEMENT"
        value={data?.nationalAgreement}
      />
      <CaptionValue
        direction="row"
        gap="4px"
        caption="BUSINESSPACKAGE"
        value={data?.businessPackage}
      />
      <CaptionValue
        direction="row"
        gap="4px"
        caption="SECTOR"
        value={data?.sector}
      />
      <StatusInfo
        fontSize="24px"
        value={data?.status}
        optionsColors={{
          AT: 'success.light',
          PE: 'warning.light',
          CH: 'error.light',
          SC: 'info.light',
        }}
      />
      <Paper
        variant="outlined"
        sx={{
          width: '100%',
          padding: '16px',
          backgroundColor: 'inherit',
          flexGrow: 1,
        }}
      >
        <Grid container spacing={2}>
          {Object.keys(data?.infos)?.map((keyName) => (
            <Grid key={keyName} size={{ sm: 4 }}>
              <CaptionValue
                captionColor="primary"
                captionStyle={{
                  fontWeight: 'bold',
                  textTransform: 'capitalize',
                }}
                caption={keyName.toUpperCase()}
                value={data?.infos[keyName]}
              />
            </Grid>
          ))}
        </Grid>
      </Paper>
    </FullSizeColumn>
  );
};

LongPracticeInfoWidget.propTypes = {
  data: PropTypes.object.isRequired,
};
export default LongPracticeInfoWidget;
